module.exports = __webpack_public_path__ + "static/img/4.68bb3b22.png";